import {Style, Icon} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class TafLayer extends GeoJsonLayer {
    types = ["wind", "vis", "wx", "cover", "ceil", "wgst", "id" ];
    icon_cache = {};

    constructor( map, settings = {}){
        settings["name"] = 'taf';
        settings["dynamic_time"] = true;
        settings["api_endpt"] = 'TafJSON.php';
        if( settings.plottype == undefined ) settings['plottype'] = "model";
        if( settings.scale == undefined ) settings['scale'] = 1;
        if( settings.density == undefined ) settings['density'] = 0;
        if( settings.metar == undefined ) settings['metar'] = false;
        if( settings.tempo == undefined ) settings['tempo'] = false;
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "decoded", true );
        url.searchParams.set( "density", this.settings['density'] );
        url.searchParams.set( "metar", Library.putBoolean(this.settings['metar']) );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        return url.toString();
    }

    getIconSize( feature ){
        var vars = this.settings['plottype'].split(",");
        var size;
        size = 80*this.settings['scale'];
        if( vars.length == 1 && this.settings['plottype'] != "" )
            size = 30*this.settings['scale'];
        if( this.settings['plottype'] == "model" ||
                this.settings['plottype'] == "cover" ||
                this.settings['plottype'] == "wind" ||
                this.settings['plottype'] == "cat" )
            size = 80*this.settings['scale'];
        if( this.settings['plottype'] == "wx" )
            size = 20*this.settings['scale'];
        return size;
    }

    getIcon( feature ){
        let isSHem = function(){ return feature.getGeometry().getCoordinates()[1] < 0 };
        let params = "scale=" + this.settings['scale'] + "&";
        let vars = this.settings['plottype'].split(",");
        if( vars.length > 1 ){
            var cover = false;
            for( var i = 0; i < vars.length; i++ ){
                if(( vars[i] == "id" ) &&
                        this.property(feature,'id') != undefined )
                    params = params + "id=" +
                        this.property(feature,'id') + "&";
                if( vars[i] == "temp" &&
                        this.property(feature,'temp') != undefined )
                    params = params + "temp=" +
                        this.map.formatter.outTemp(this.property(feature,'temp')) + "&";
                if( vars[i] == "dew" &&
                        this.property(feature,'dewp') != undefined )
                    params = params + "dewp=" +
                        this.map.formatter.outTemp(this.property(feature,'dewp')) + "&";
                if( vars[i] == "alt"  &&
                        this.property(feature,'altim') != undefined )
                    params = params + "altim=" +
                        this.map.formatter.outAltim(this.property(feature,'altim')) + "&";
                if( vars[i] == "cover" ){
                    if( this.property(feature,'cover') != undefined ){
                        params = params + "cover=" +
                            this.property(feature,'cover') + "&";
                        if( this.property(feature,'fltcat') != undefined )
                            params = params + "fltcat=" + this.property(feature,'fltcat') + "&";
                    }
                    cover = true;
                }
                if( vars[i] == "ceil" &&
                        this.property(feature,'ceil') != undefined )
                    params = params + "ceil=" +
                        this.property(feature,'ceil') + "&";
                if( vars[i] == "wind" ){
                    if( this.property(feature,'wspd') != undefined )
                        params = params + "wspd=" +
                            this.property(feature,'wspd') + "&";
                    if( this.property(feature,'wdir') != undefined ){
                        if( isSHem() )
                            params = params + "wdir=" + -this.property(feature,'wdir') + "&";
                        else
                            params = params + "wdir=" + this.property(feature,'wdir') + "&";
                    }
                }
                if( vars[i] == "wgst" ){
                    if( this.property(feature,'wgst') != undefined )
                        params = params + "wgst=" + this.property(feature,'wgst') + "&";
                    if( this.property(feature,'wdir') != undefined ){
                        if( isSHem() )
                            params = params + "wdir=" + -this.property(feature,'wdir') + "&";
                        else
                            params = params + "wdir=" + this.property(feature,'wdir') + "&";
                    }
                }
                if( vars[i] == "vis" &&
                        this.property(feature,'visib') != undefined ){
                    params = params + "visib=" +
                        this.map.formatter.outVisib(this.property(feature,'visib')) + "&";
                }
                if( vars[i] == "wx" &&
                        this.property(feature,'wx') != undefined ){
                    var wx = this.property(feature,'wx').replace( "+", "%2B" );
                    params = params + "wx=" + wx + "&";
                }
            }
            if( !cover ) params = params + "cover=S&";
            return this.icon_path+'/stationicon.php?'+params;
        }

        if( this.settings['plottype'] == "" || this.settings['plottype'] == "none" ){
            return this.icon_path+'/stationicon.php?cover=S';
        }
        else if( this.settings['plottype'] == "model" ){
            if( this.property(feature,'id') != undefined )
                params = params + "id=" +
                    this.property(feature,'id') + "&";
            if( this.property(feature,'temp') != undefined )
                params = params + "temp=" +
                    this.map.formatter.outTemp(this.property(feature,'temp')) + "&";
            if( this.property(feature,'dewp') != undefined )
                params = params + "dewp=" +
                    this.map.formatter.outTemp(this.property(feature,'dewp')) + "&";
            if( this.property(feature,'altim') != undefined )
                params = params + "altim=" +
                    this.map.formatter.outAltim(this.property(feature,'altim')) + "&";
            if( this.property(feature,'cover') != undefined )
                params = params + "cover=" +
                    this.property(feature,'cover') + "&";
            if( this.property(feature,'ceil') != undefined )
                params = params + "ceil=" +
                    this.property(feature,'ceil') + "&";
            if( this.property(feature,'wspd') != undefined )
                params = params + "wspd=" +
                    this.property(feature,'wspd') + "&";
            if( this.property(feature,'wgst') != undefined )
                params = params + "wgst=" + this.property(feature,'wgst') + "&";
            if( this.property(feature,'wdir') != undefined ){
                if( isSHem() )
                    params = params + "wdir=" + -this.property(feature,'wdir') + "&";
                else
                    params = params + "wdir=" + this.property(feature,'wdir') + "&";
            }
            if( this.property(feature,'visib') != undefined )
                params = params + "visib=" +
                    this.map.formatter.outVisib(this.property(feature,'visib')) + "&";
            if( this.property(feature,'wx') != undefined ){
                var wx = this.property(feature,'wx').replace( "+", "%2B" );
                params = params + "wx=" + wx + "&";
            }
            if( this.property(feature,'fltcat') != undefined )
                params = params + "fltcat=" + this.property(feature,'fltcat') + "&";
            return this.icon_path+'/stationicon.php?'+params;
        }
        else if( this.settings['plottype'] == "id" ){
            params = params + "text=" +
                this.property(feature,'id');
            return this.icon_path+'/txticon.php?'+params;
        }
        else if( this.settings['plottype'] == "temp" ){
            params = params + "text=" +
                this.map.formatter.outTemp(this.property(feature,'temp')) + "&";
            return this.icon_path+'/txticon.php?'+params;
        }
        else if( this.settings['plottype'] == "dew" ){
            params = params + "text=" +
                this.map.formatter.outTemp(this.property(feature,'dewp')) + "&";
            return this.icon_path+'/txticon.php?'+params;
        }
        else if( this.settings['plottype'] == "rhum" ){
            params = params + "text=" +
                this.map.formatter.outRelHum(this.property(feature,'temp'), this.property(feature,'dewp')) + "&";
            return this.icon_path+'/txticon.php?'+params;
        }
        else if( this.settings['plottype'] == "alt" ){
            params = params + "text=" +
                this.map.formatter.outAltim(this.property(feature,'altim')) + "&";
            return this.icon_path+'/txticon.php?'+params;
        }
        else if( this.settings['plottype'] == "vis" ){
            params = params + "text=" +
                this.map.formatter.outVisib(this.property(feature,'visib')) + "&";
            return this.icon_path+'/txticon.php?'+params;
        }
        else if( this.settings['plottype'] == "ceil" ){
            if( this.property(feature,'ceil') != undefined ){
                params = params + "text=" + Math.round(this.property(feature,'ceil')) + "&";
                return this.icon_path+'/txticon.php?'+params;
            }
        }
        else if( this.settings['plottype'] == "cover" ){
            if( this.property(feature,'fltcat') != undefined )
                params = params + "fltcat=" + this.property(feature,'fltcat') + "&";
            if( this.property(feature,'cover') != undefined ){
                params = params + "cover=" + this.property(feature,'cover') + "&";
                return this.icon_path+'/stationicon.php?'+params;
            } else
                return this.icon_path+'/stationicon.php?'+params+"cover=M";
        }
        else if( this.settings['plottype'] == "wind" ){
            params = "cover=S&";
            if( this.property(feature,'wspd') != undefined )
                params = params + "wspd=" + this.property(feature,'wspd') + "&";
            if( this.property(feature,'wdir') != undefined ){
                if( isSHem() )
                    params = params + "wdir=" + -this.property(feature,'wdir') + "&";
                else
                    params = params + "wdir=" + this.property(feature,'wdir') + "&";
            }
            return this.icon_path+'/stationicon.php?'+params;
        }
        else if( this.settings['plottype'] == "wdir" ){
            params = params + "text=" + Math.round(this.property(feature,'wdir')) + "&";
            return this.icon_path+'/txticon.php?'+params;
        }
        else if( this.settings['plottype'] == "wspd" ){
            params = params + "text=" + Math.round(this.property(feature,'wspd')) + "&";
            return this.icon_path+'/txticon.php?'+params;
        }
        else if( this.settings['plottype'] == "wgst" ){
            if( this.property(feature,'wgst') != undefined ){
                params = params + "text=" + Math.round(this.property(feature,'wgst')) + "&";
                return this.icon_path+'/txticon.php?'+params;
            }
        }
        else if( this.settings['plottype'] == "cat" ){
            if( this.property(feature,'fltcat') != undefined )
                params = params + "code=" + this.property(feature,'fltcat') + "&";
            return this.icon_path+'/wxicon.php?'+params;
        }
        else if( this.settings['plottype'] == "wx" ){
            if( this.property(feature,'wx') != undefined ){
                var wx = this.property(feature,'wx').replace( "+", "%2B" );
                params = params + "code=" + this.property(feature,'wx') + "&";
            }
            return this.icon_path+'/wxicon.php?'+params;
        }
        return this.icon_path+'/txticon.php?text=-';
    }

    getStyle(feature, resolution ){
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[ feature.getId()] ){
            icon = this.icon_cache[feature.getId()];
        } else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }

        let style = new Style({
                "image": icon
                });
        return style;
    }

    getPopupText( feature ){
        let text = this.popupTitle( "TAF", this.property(feature,'id') + 
                " ["+this.property(feature,'site') + "]" );
        if( this.property(feature,'raw_ob') ){
            text += this.popupData( "METAR", this.property(feature,'raw_ob') );
            text += this.popupSep();
        }
        if( this.settings['decoded'] ){
            if( this.property(feature,'obs_time') != undefined )
                text += this.popupData( "Time", this.property(feature,'obs_time'));
            if( this.property(feature,'temp') != undefined )
                text += this.popupData( "Temperature",
                    this.map.formatter.outTemp(this.property(feature,'temp')) +
                    "&deg;" + this.map.formatter.outTempUnits());
            if( this.property(feature,'dewp') != undefined )
                text += this.popupData( "Dewpoint",
                    this.map.formatter.outTemp(this.property(feature,'dewp')) +
                    "&deg;" + this.map.formatter.outTempUnits());
            if( this.property(feature,'altim') != undefined )
                text += this.popupData( "Altimeter",
                    this.map.formatter.outAltimLong(this.property(feature,'altim')) +
                    " " + this.map.formatter.outAltimUnits());
            if( this.property(feature,'visib') != undefined )
                text += this.popupData( "Visibility",
                    this.map.formatter.outVisib(this.property(feature,'visib')) +
                    " " + this.map.formatter.outVisibUnits());
            if( this.property(feature,'ceil') != undefined )
                text += this.popupData( "Ceiling", this.property(feature,'ceil') + "00 ft");
            if( this.property(feature,'cover') != undefined )
                text += this.popupData( "Max Cloud Cover", this.property(feature,'cover'));
            clouds = "";
            for( let i = 0; i < this.property(feature,'clouds').length; i++ ){
                if( this.property(feature,'clouds')[i]['base'] != undefined )
                    clouds = clouds +this.property(feature,'clouds')[i]['base'] + ' ';
                if( this.property(feature,'clouds')[i]['cover'] != undefined )
                    clouds = clouds + this.property(feature,'clouds')[i]['cover'];
                if( this.property(feature,'clouds')[i]['type'] != undefined )
                    clouds = clouds + "/" + this.property(feature,'clouds')[i]['type'];
                clouds += ',';
            }
            clouds = clouds.replace( /,$/, "" );
            if( clouds != "" )
                text += this.popupData( "Cloud Layers", clouds );
            if( this.property(feature,'wdir') != undefined ){
                if( this.property(feature,'wdir') == 0 && this.property(feature,'wspd') == 0 )
                    wind += this.popupData( "Winds", "calm" );
                else if( this.property(feature,'wdir') == 0 )
                    text += this.popupData( "Winds", "Variable at " + this.property(feature,'wspd') + " kt" );
                else {
                    let wind = this.property(feature,'wdir') +
                        "&deg; at " + this.property(feature,'wspd') + " kt";
                    if( this.property(feature,'wgst') != undefined )
                        wind += " " + this.property(feature,'wgst') + " kt";
                    text += this.popupData( "Winds", winds );
                }
            }
            if( this.property(feature,'wx') != undefined )
                text += this.popupData( "Weather", this.property(feature,'wx') );
            if( this.property(feature,'fltcat') != undefined )
                text += this.popupData( "Flight Category", this.property(feature,'fltcat'));
        } else {
            let taf = this.property(feature,'raw_taf').replace( "FROM", "<br/>&nbsp;&nbsp;FROM" );
            taf = taf.replace( /FM0/g, "<br/>&nbsp;&nbsp;FM0" );
            taf = taf.replace( /FM1/g, "<br/>&nbsp;&nbsp;FM1" );
            taf = taf.replace( /FM2/g, "<br/>&nbsp;&nbsp;FM2" );
            taf = taf.replace( /FM3/g, "<br/>&nbsp;&nbsp;FM3" );
            taf = taf.replace( /TEMPO/g, "<br/>&nbsp;&nbsp;TEMPO" );
            taf = taf.replace( /BECMG/g, "<br/>&nbsp;&nbsp;BECMG" );
            taf = taf.replace( /PROB/g, "<br/>&nbsp;&nbsp;PROB" );
            taf = taf.replace( /INTER/g, "<br/>&nbsp;&nbsp;INTER" );
            text += this.popupData( "TAF", taf );
        }
        text += this.popupEnd();
        return text;
    }

    setPlotType(val, refresh = true){
        console.info( val);
        if( val == undefined ){
            let params = [];
            for( let i = 0; i < this.types.length; i++ ){
                if( Library.getCheckbox( "check_taf_plottype_"+this.types[i] )){
                    params.push( this.types[i]);
                }
            }
            this.settings['plottype'] = params.join(",");
        } else {
            if( val == "all" ) val = "model";
            let params = val.split(",");
            if( params.length == 10 ) params = ["model"];
            if( params[0] == "model" || params[0] == "all" ){
                for( let i = 0; i < this.types.length; i++ )
                    Library.setCheckbox( "check_taf_plottype_"+this.types[i], true );
            } else {
                for( let i = 0; i < this.types.length; i++ )
                    Library.setCheckbox( "check_taf_plottype_"+this.types[i], false );
            }
            for( let i = 0; i < params.length; i++ )
                Library.setCheckbox( "check_taf_plottype_"+params[i], true );

            this.settings['plottype'] = val;
        }
        if( refresh ){
            this.icon_cache = {};
            this.refresh();
        }
    }

    setScale(val){
        this.settings['scale'] = val;
        this.icon_cache = {};
        this.refresh();
    }
    updateTime(){
        this.refresh();
    }
}